
/**
 * @brief Ce composant est construit selon les attributs d'un objet JSON déclaré dans le fichier de langue.
 *
 * Cet élément permet de construite un Tag pour chaque filtre actif.
 * En cliquant sur le Tag, l'élément est supprimé des filtre de recherche une actualisation de la recherche est lancée.
 *
 * @remark
 * Seule le champ activeFilter[index].title contient la valeur de la langue.
 * Tous les autres champs sont des attributs du composant et ne doivent pas être traduits !
 *
 * @code
 *     "activeFilter": [
 *         // ORDRE       INPUT $_GET           GROUPE DU FILTRE         NOM DU FILTRE            TYPE                TITRE AFFICHÉ (state.locale)
 *         { "order": 1,  "id": "keyword",      "group": "keyword",      "name": "keyword",       "type": "string",   "title": "Mot-Clé" },
 *         { "order": 2,  "id": "prix",         "group": "price",        "name": "price",         "type": "range",    "title": "Prix",                "format": "%min%$ ~ %max%$" },
 *         { "order": 3,  "id": "carrosserie",  "group": "carrosserie",  "name": "carrosserie",   "type": "list",     "title": "Type de Véhicule" },
 *         { "order": 4,  "id": "categorie",    "group": "category",     "name": "category",      "type": "list",     "title": "Catégorie" },
 *         { "order": 5,  "id": "marque",       "group": "brand&model",  "name": "brand",         "type": "string",   "title": "Marque" },
 *         { "order": 6,  "id": "model",        "group": "brand&model",  "name": "model",         "type": "string",   "title": "Modèle" },
 *         { "order": 7,  "id": "annee",        "group": "year",         "name": "year",          "type": "range",    "title": "Année",               "format": "%min% ~ %max%" },
 *         { "order": 8,  "id": "odo",          "group": "odometer",     "name": "odometer",      "type": "range",    "title": "Odomètre",            "format": "%min% Km ~ %max% Km" },
 *         { "order": 9,  "id": "nbPassager",   "group": "passenger",    "name": "passenger",     "type": "select",   "title": "Nombre de passagers", "format": "%value% Passager%plural%" },
 *         { "order": 10, "id": "traction",     "group": "traction",     "name": "traction",      "type": "list",     "title": "Traction" },
 *         { "order": 11, "id": "energie",      "group": "energy",       "name": "energy",        "type": "list",     "title": "Énergie" },
 *         { "order": 12, "id": "transmission", "group": "transmission", "name": "transmission",  "type": "list",     "title": "Transmission" },
 *         { "order": 13, "id": "moteur",       "group": "engine",       "name": "engine",        "type": "list",     "title": "Moteur" },
 *         { "order": 14, "id": "couleurExt",   "group": "extColor",     "name": "extColor",      "type": "list",     "title": "Couleur Extérieure" },
 *         { "order": 15, "id": "couleurInt",   "group": "intColor",     "name": "intColor",      "type": "list",     "title": "Couleur Intérieure" }
 *     ]
 *
 * (number) order  : ordre d'affichage
 * (string) id     : identifiant du champ arrivant du $_GET
 * (string) group  : groupe de filtres
 * (string) name   : nom du filtre associé au groupe, permet d'aller chercher la valeur du filtre via state.filter[group][name]
 * (string) type   : type du filtre permettant de construire le bon Tag
 * (string) title  : libellé du Tag
 * (string) format : formatage de la valeur à renvoyer (NULL par défaut)
 */
import { defineComponent } from 'vue'
import recherchevehicule from "@/services/recherche_page.services"

export default defineComponent({
  name: 'activeFilter',
  props: {
    locale: String,
    order: Number,
    group: String,
    name: String,
    type: String,
    title: String,
    value: Object,
    format: String,
    invalid: Boolean
  },
  setup: (props: any) => {
    const {
      removeActiveFilter
    } = recherchevehicule;
    function formatContent(): string|object {
      let label = "";
      // Formatage du champ si l'attribut est présent
      if (typeof (props.format) == undefined || String(props.format || '').length == 0) {
        // Pas de formatage
        label = props.value;
      } else if (props.type == 'range') {
        // Formatage du champ de type range
        let min = props.group != 'year' ? Number(props.value.min).toLocaleString(props.locale) : props.value.min;
        let max = props.group != 'year' ? Number(props.value.max).toLocaleString(props.locale) : props.value.max;
        label = props.format.replace("%min%", min).replace("%max%", max);
      } else {
        // Formatage du champ par défaut
        label = props.format.replace("%value%", String(props.value)).replace("%plural%", Number(props.value) > 1 ? 's' : '');
      }
      return label;
    }
    return {
      removeActiveFilter,
      formatContent
    }
  }
})
